/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SelectFieldOption } from '@squiz/sds';

/**
 * A function used to create an array of select fields from a mapping.
 * @param {Map<string, string> | Array<Array<string>>} optionMap Mapped select field options with friendly text as values.
 * @export
 * @returns {Array<SelectFieldOption>} An array of select options created from the option map.
 */
export const buildSelectOptions = (optionMap: Map<string, string> | Array<Array<string>>): Array<SelectFieldOption> => {
  const options: Array<SelectFieldOption> = [];

  for (const [key, name] of optionMap.entries()) {
    options.push({ ['key']: key as string, ['label']: name as string, ['value']: key as string });
  }

  return options;
};
